<template>
  <div class="guardianBoxHome">
    <div class="img-guardianBoxHome">
      <img src="https://mediakit.enabot.com/eboX/img/pc/Guardian.png" alt="">
    </div>
    <div class="guardianBoxHome-box">
      <div class="swiper-container2 swiper-guardianBoxHome">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/guardianBoxHome1.png" alt="">
          </div>
          <div class="swiper-slide">
            <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/guardianBoxHome2.png" alt="">
          </div>
          <div class="swiper-slide">
            <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/guardianBoxHome3.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-wrap">
      <span @click="selectSwiperActive(index)" :class="['pagination-span',{'pagination-span-active':index === activeIndex}]" v-for="(item,index) in ['1','2','3']" :key="index"></span>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      list: [
        // { img: require("https://mediakit.enabot.com/eboX/img/pc/Family.png"), text: "Your Family's Protector" },
        // { img: require('https://mediakit.enabot.com/eboX/img/pc/Family1.png'), text: "Your Family's Companion" },
        // { img: require('https://mediakit.enabot.com/eboX/img/pc/Family2.png'), text: "Your Family's Playmate" },
        { img: "https://mediakit.enabot.com/eboX/img/pc/Family.png", text: "Your Family's Protector" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/Family1.png', text: "Your Family's Companion" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/Family2.png', text: "Your Family's Playmate" },
      ],
      activeIndex:0
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.$emit('handleActiveIndex',{activeIndex:this.activeIndex})
      this.pcinit()
    })
  },
  methods: {
    pcinit() {
      this.SwiperBox = new Swiper(".swiper-guardianBoxHome", {
        // direction: 'vertical', // 垂直切换选项
        slidesPerView: 3,
        loop: true, // 循环模式选项
        slideToClickedSlide: true,
        // autoplay:true,
        sapceBetween:40,
        centeredSlides: true,
        resistanceRatio:0,
        on: {
            // 该方法中的this都指代swiper本身
            // tap: function () {
            //     console.log('点击的位置', this.activeIndex);
            // }
            slideChangeTransitionEnd:  () =>{
              // let swiper = this.$refs.mySwiper.$swiper;
              // let activeIndex = swiper.activeIndex;
              if(this.SwiperBox){
                console.log(this.SwiperBox.realIndex)
                this.activeIndex = this.SwiperBox.realIndex
                this.$emit('handleActiveIndex',{activeIndex:this.activeIndex})
              }
              
            }
        }
      });
    },
    selectSwiperActive(index) {
      this.SwiperBox.slideToLoop(index)
    }
  },

}
</script>


<style lang="scss">
.guardianBoxHome{
  .swiper-container2 {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
  }
  .swiper-slide{
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
    .swiper-wrapper-img{
      width:100%;
      height: auto;
    }
    
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
      // background-color: aqua;
      transform: scale(1);
  }
  .pagination-wrap{
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    .pagination-span{
      display: inline-block;
      width: 16px;
      height: 16px;
      // background-color: #;
      border-radius: 50%;
      border: 1px solid #FFFFFF;
      margin: 36px 10px 0 10px;
      cursor: pointer;
    }
    .pagination-span-active{
      background-color: #FFFFFF;
    }
  }
}
</style>
<style lang="scss" scoped>
.guardianBoxHome{
  .img-guardianBoxHome {
    width: 806px;
    height: 47px;
    margin: 0 auto;
    margin-bottom: 69px;
    margin-top: 120px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  
  .guardianBoxHome-box {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    justify-content: space-between;

    .list-box {
      width: 32.1%;
      height: auto;
      text-align: center;
      position: relative;
      .text {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        top: 80%;
        font-size: 24px;
        // font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 26px;
      }
    }
  }
  
}
</style>